export default __webpack_public_path__ + "media/images/logo_alt-152a1da6f5c0b3c65b3f29a2b307631b.svg";